import { ReturnSliderProps } from "./types";
import { Hint, Range, ValueLabel, ValueRow, Wrapper } from "./styles";

const DEFAULT_MIN = 0;
const DEFAULT_MAX = 0.2;
const DEFAULT_STEP = 0.005;
const PERCENT = 100;

export const ReturnSlider = ({
  value,
  onChange,
  disabled = false,
  min = DEFAULT_MIN,
  max = DEFAULT_MAX,
  step = DEFAULT_STEP,
}: ReturnSliderProps) => {
  const percentLabel = (value * PERCENT).toFixed(1) + "%";

  return (
    <Wrapper>
      <ValueRow>
        <ValueLabel>{percentLabel}</ValueLabel>
        <Hint>assumed annual return</Hint>
      </ValueRow>
      <Range
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(Number(event.target.value))}
        aria-label="Assumed annual return"
      />
    </Wrapper>
  );
};
